import React from 'react';

import StorytellerUtils from 'lib/StorytellerUtils';
import { type ReactRendererProps } from '../shared/ComponentRegistry';
import { type Crop } from 'react-image-crop';

interface ImageValue {
  url: string;
  documentId: string | null;
  link?: string;
  alt?: string;
  openInNewWindow?: boolean;
  crop?: Crop;
}

export const ComponentImage = ({ componentData, editMode }: ReactRendererProps) => {
  const value = (componentData?.value ?? null) as ImageValue | null;
  const typeClasses = StorytellerUtils.typeToClassesForComponentType(componentData?.type);

  if (!value?.url) {
    return null;
  }

  const cropJson = JSON.stringify(value.crop ?? {});
  const hasLink = value.link && value.link.length > 0;
  const openInNewWindow = editMode || value.openInNewWindow;

  const handleImageLoad = (event: React.SyntheticEvent<HTMLImageElement>) => {
    event.currentTarget.dispatchEvent(
      new CustomEvent('component::height-change', { detail: {}, bubbles: true }),
    );
  };

  const imgElement = (
    <img
      src={value.url}
      data-src={value.url}
      data-document-id={value.documentId}
      data-crop={cropJson}
      alt={value.alt ?? ''}
      onLoad={handleImageLoad}
    />
  );

  return (
    <div className={`component ${typeClasses}`}>
      {hasLink ? (
        <a href={value.link} target={openInNewWindow ? '_blank' : undefined} rel="noopener noreferrer">
          {imgElement}
        </a>
      ) : (
        <a>{imgElement}</a>
      )}
    </div>
  );
};
